import { useEffect, useMemo } from 'react';
import { IconType } from '../../icon/icon_dictionary';
import { useInputComboboxContext } from './_input_combobox.context';
import { InputComboboxOptionAvatar } from './input_combobox_root.component';

interface InputComboboxItemProps {
	label: string;
	value: string;
	subLabel?: string;
	icon?: IconType;
	avatar?: InputComboboxOptionAvatar;
	disabled?: boolean;
}

export function InputComboboxItem({ label, value, subLabel, icon, avatar, disabled }: InputComboboxItemProps) {
	const { onOptionAdd, onOptionRemove } = useInputComboboxContext();
	const option = useMemo(() => ({ label, value, subLabel, icon, avatar, disabled }), [label, value, subLabel, icon, avatar, disabled]);

	// biome-ignore lint/correctness/useExhaustiveDependencies: suppressed due to migration - should be fixed
	useEffect(function whenMount() {
		onOptionAdd(option);

		return function whenUnmount() {
			onOptionRemove(option);
		};
	}, []);

	return null;
}
